<template>
    <div>
        <video v-if="show" class="audioControls" controls="controls" preload="none"> 
            <source :src="src"  type="video/mp4">
        </video>
    </div>
</template>

<script>
export default {
    props:['src'],
    data: function(){
        return {
            show: true,
        }
    },
    watch: {
        src: function(data){
            this.show = false;
            setTimeout(()=>{
                this.show = true;
            },100)
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?4084d78a